var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",staticClass:"newmodal",class:{visible: _vm.isVisible},on:{"click":_vm.hide}},[_c('div',{staticClass:"newmodal__body",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }